import { encodePublicImagePath as p } from "@/lib/encodePublicImagePath";

/** Hero images on procedure pages (files live in `frontend/public/`). */
export const HERO = {
  rhinoplasty: p("RHINOPLASTY.jpg"),
  liquidRhinoplasty: p("LIQUID RHINOPLASTY.jpg"),
  tummyTuck: p("TUMMY TUCK.jpg"),
  liposuction: p("LIPOSUCTION.jpg"),
  facelift: p("FACELIFT.jpg"),
  gynecomastia: p("GYNECOMASTIA.jpg"),
  breastAugmentation: p("breast implants.jpg"),
  breastLift: p("breast lift.jpg"),
  breastReduction: p("breast reduction.jpg"),
  breastFatTransfer: p("BREAST FAT GRAFTING (1).jpg"),
  breastImplantRemoval: p("IMPLANT REMOVAL.jpg"),
  axillaryBreast: p("axillary breast.jpg"),
  mommyMakeover: p("mommy makeover.jpg"),
  bodyLift: p("Body lift.jpg"),
  buttockAugmentation: p("BRAZILIAN BUTT LIFT.jpg"),
  thighLift: p("THIGH LIFT.jpg"),
  otoplasty: p("OTOPLASTY.jpg"),
  blepharoplasty: p("BLEPHAROPLASTY.jpg"),
  neckLift: p("necklift.jpg"),
  threadLift: p("Thread lift.jpg"),
  chinAugmentation: p("hero-chin-augmentation.png"),
  cheekAugmentation: p("hero-cheek-augmentation.png"),
  doubleChinRemoval: p("double chin.jpg"),
  buccalFatRemoval: p("hero-buccal-fat-removal.png"),
  earlobeRepair: p("ear lobe.jpg"),
  prpTherapy: p("prp.jpg"),
  hairTransplant: p("hair transplant.jpg"),
  hairFallHairLoss: p("hair loss treatment.jpg"),
  beardTransplant: p("Beard Transplant.jpg"),
  botox: p("Botox.jpg"),
  dermalFillers: p("DERMAL FILLERS.jpg"),
  chemicalPeel: p("VICKY/Non Surgical/Chemical peel.jpg"),
  burnReconstruction: p("BURNS.jpg"),
  skinGrafting: p("SKIN GRAFT.jpg"),
  scarManagement: p("scar removal surgery.jpg"),
  moleRemoval: p("MOLE REMOVAL.jpg"),
  sebaceousCystRemoval: p("CYST.jpg"),
  wartRemoval: p("WARTS.jpg"),
  neurofibromaRemoval: p("NEUROFIBROM.jpg"),
  fibroadenoma: p("FIBROADENOMA.jpg"),
  maleNippleReduction: p("LARGE NIPPLES.jpg"),
  invertedNippleCorrection: p("INVERTED NIPPLE.jpg"),
  armLift: p("brachioplasty arm lift.jpg"),
  skinTagRemoval: p("VICKY/Surgical/SKIN TAGS.avif"),
  nailRemoval: p("VICKY/Surgical/NAIL.avif"),
  keloidTreatment: p("hero-keloid-treatment.png"),
  lipomaRemoval: p("hero-lipoma-removal.png"),

  /** Foot corn / callus (clinical context) */
  cornRemoval: p("peeling-feet-pedicure-procedure-from-callus-on-foo-2026-03-26-04-01-17-utc-2.jpg"),

  /** ProcedureDetailPage heroes */
  diabeticFoot: p("Diabetic foot-2.jpg"),
  limbSalvage: p("Limb salvage-2.jpg"),
  migraineSurgery: p("Migraine surgery-2.jpg"),
  scalpReduction: p("Scalp reduction-2.jpg"),
  spiderVein: p("Spider vein treatment-2.jpg"),

  cleftLipPalate: p("cleft.jpg"),
  dimpleplasty: p("dimple.png"),
};
